<template>
    <div>
        <div class="ui inverted dimmer transition" :class="{'active': is_loading}">
            <div class="ui text loader">
                <!-- 處理中... -->
                {{ $t('ui.general.initializing') }}
            </div>
        </div>

        <div class="clear"></div>
        <div class="ui segment">
            <div v-if="style.width < 767" style="margin-bottom: 1em;">
                <div v-if="is_loading">
                    <div class="ui active centered inline loader"></div>
                </div>
                <DataCard
                    v-else
                    v-for="partition in parent_partitions"
                    :key="partition.identity"
                    :object="partition"
                    :title="partition.name"
                    :is_show_column="true"
                    :i_18n_key="'partitions'"
                    :keys="['numbers_from','numbers_to','total_amount','available_quantity','parent','customer','note']"
                >
                    <span slot="total_amount">
                        {{ $store.getters[store_key+'number_with_commas'](partition.numbers_amount) }}
                    </span>
                    <span slot="available_quantity">
                        {{ $store.getters[store_key+'number_with_commas'](partition.remaining_numbers) }}
                    </span>
                    <span slot="customer">
                        <router-link v-if="$store.getters[store_key+'current_customer'](partition)" :to="{name: 'customer', params: {customer_identity: $store.getters[store_key+'current_customer'](partition).identity}}">
                            {{ $store.getters[store_key+'current_customer'](partition).company_short_name || $store.getters[store_key+'current_customer'](partition).identity }}
                        </router-link>
                        <span v-else>
                            {{
                                partition.partition_type == "Auto"
                                ? $t('ui.pages.partitions.automatic_number')
                                :provider_node.company_short_name
                            }}
                        </span>
                    </span>
                </DataCard>

                <div v-if="!is_loading && parent_partitions.length <= 0"
                    class="ui center aligned red segment">
                    <h3>
                        {{ $t('ui.general.no_data') }}
                    </h3>
                </div>
            </div>
            <table v-else class="ui celled table">
                <thead>
                    <tr>
                        <th>{{ $t('models.attributes.partitions.name') }}</th>
                        <th>{{ $t('models.attributes.partitions.numbers') }}</th>
                        <th>{{ $t('models.attributes.partitions.parent') }}</th>
                        <th>{{ $t('models.attributes.partitions.customer') }}</th>
                        <th>{{ $t('models.attributes.partitions.note') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <Row v-if="is_initialized" v-for="partition in parent_partitions" :key="partition.identity" :partition="partition">
                    </Row>
                </tbody>
            </table>

            <Paginator
                :total_pages="Number(current_store.pagination.total_pages)"
                :current_page="Number(current_store.pagination.current_page)">
            </Paginator>
        </div>
    </div>
</template>

<script>
import Row from "./row.vue"
import DataCard from '@toolbox/data_card/main.vue'
import Paginator from '@toolbox/pagination/paginator.vue'

export default {
    name: "AssociatedPartitionsIndex",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            store_key: 'provider/partitions_module/'
        }
    },
    created() {
        this.init();
    },
    mounted() {
    },
    beforeDestroy() {
        this.current_store.pagination.current_page = 1;
    },
    watch: {
        '$route': {
            async handler(to, from) {
                var page = to.query.page;
                if (page) {
                    this.current_store.pagination.current_page = Number(page);
                    await new Promise(resolve => {
                        this.is_loading = true;
                        resolve();
                    });
                    await this.$store.dispatch('provider/partitions_module/fetch_associated_partitions', {
                        page: page
                    });
                    await new Promise(resolve => {
                        this.is_loading = false;
                        resolve();
                    });
                }

                if (to.name == "partitions") {
                    this.init();
                }
            },
            deep: true,
        },
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.current_store.pagination.current_page = (this.$route.query.page)
                    ? this.$route.query.page
                    : 1
                this.is_initialized = false;
                resolve();
            });
            await this.$store.dispatch('provider/partitions_module/fetch_associated_partitions', {
                page: this.current_store.pagination.current_page
            });
            await new Promise(resolve => {
                this.is_initialized = true;
                resolve();
            });
        }
    },
    computed: {
        style: (instance) => instance.$store.state.style,
        current_store: (instance) => instance.$store.state.provider.partitions_module,
        provider_node: (instance) => instance.$store.state.provider.node,
        parent_partitions() {
            return _.filter(this.current_store.associated_partitions, partition => {
                return partition.parent_identity == null
            })
        }
    },
    components: {
        Row,
        DataCard,
        Paginator,
    }
}
</script>

<style lang="scss">
</style>
